import { useEffect, useState } from "react";
import InputB from "../../../components/InputB/InputB";
import ItemLocationDTO from "../../DTO/ItemLocationDTO";
import { Plus } from "react-feather";
import ItemsDTO from "../../DTO/ItemsDTO";
import { Status } from "../day/dayView";
import Spinner from "../../../components/Spinner/Spinner";
import Location from "./Location";
import Menu, { MItem } from "../Menu";
import PlaningToolRoot from "../PlaningToolRoot";
import { sessionDataSaver } from "../../../services/SessionDataSaver";
import { Box, Table, TableBody } from "@mui/material";

export default function LocationList(props: {
  selected?: number,
  onSelect?: (id: number, location: ItemLocationDTO) => void,
  className?: string,
  standalone?: boolean,
  headline?: string,
  withAddress?: boolean,
}) {
  const searchNeedlePlaceholder = `${props.standalone ? 'Standalone' : 'Local'}-locationNeedle`
  const rememberNeedles = !!props.standalone
  const [Needle, setNeedle] = useState(sessionDataSaver.get(searchNeedlePlaceholder, rememberNeedles))
  const [status, setStatus] = useState(Status.loading)
  const [Items] = useState(new ItemsDTO({
    getUrl: 'spt/location/list',
    trashUrl: 'spt/location/delete',
    needle: Needle,
  }))
  const className = `STLocationList flex flex-column ${props.className || ''}`
  function setGlobNeedle(n: string) {
    sessionDataSaver.set(searchNeedlePlaceholder, n)
    setNeedle(n)
  }
  useEffect(() => {
    Items.getFromServer().then(() => {
      setStatus(Status.standard)
    })
  }, [])
  return <PlaningToolRoot standalone={props.standalone} menuItem={MItem.locations} mainContentClass={className}>
    {
      (props.standalone || props.headline) ?
      <div className='contentHeader'>
        {
          props.headline ? <h2>{props.headline}</h2> : <h1>Veranstaltungsorte</h1>
        }
        <div className="flex">
          <InputB
            className='flex-grow'
            returnVal={async (val) => {
              setStatus(Status.loading)
              await Items.setNeedle(val)
              setGlobNeedle(val)
              setStatus(Status.standard)
            }}
            placeholder='Tippen um zu suchen oder neu anzulegen ...'
            value={Needle}
            clearButton={true}
            sendButton="Suchen"
            delay={-1}
          />
        </div>
        {
          Needle !== '' &&
          <button
            className='positiveButton'
            onClick={async () => {
              const item = new ItemLocationDTO({})
              await item.setName(Needle)
              if (props.onSelect) {
                props.onSelect(item.id, item)
              } else {
                setStatus(Status.loading)
                await Items.getFromServer()
                setStatus(Status.standard)
              }
            }}
          ><Plus /></button>
        }
      </div> : null
    }
    <Box
      sx={{bgcolor: '#fff'}}
      className={`LocationList ${props.standalone ? 'scrollContent' : ''}`}
    >
      {
        status === Status.loading &&
        <Spinner />
      }
      <Table>
        <TableBody>
        {
          Items.getItems().map((i, index) => {
            return <Location
                key={`LocationListItem-${i.id}`}
                className={`${props.selected === i.id ? 'mark' : ''}`}
                item={i}
                onClick={props.onSelect}
                onTrash={props.standalone ? async () => {
                  if (!window.confirm(`${i.name} wirklich löschen?`)) { return }
                  setStatus(Status.loading)
                  await Items.trashItem(i.id)
                  setStatus(Status.standard)
                } : undefined}
                withAddress={props.withAddress}
              />
          })
        }
        </TableBody>
      </Table>
      
    </Box>
  </PlaningToolRoot>
}
